/*
 * Copyright (c) 2023
 * 
 * Created Date: Friday, October 27th 2023, 9:39:21 am
 * Author: 🫰Aris Bimas Nugroho
 * 
 */
import { Button, Card, Form, Input } from 'antd'
import useSimpleCaptcha from 'hooks/useSimpleCaptcha'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { RouteConstant } from 'routes/routesConstant'
import useUserRepo from 'services/repo/useUserRepo'
import Constant from 'utils/Constants'
import CustomAlert from 'utils/CustomAlert'
import DevLog from 'utils/DevLog'
import BrandLogo from 'assets/img/LOGO-FULL-DARK.png'

const propsItem = {
    colon: false,
    labelCol: { sm: 12 },
    validateTrigger: false,
    className: "form-item-forgot-password"
}

const styleFormItem = {
    marginBottom: "0"
}


export default function ForgetPassword() {
    const { isLoading, sendLinkResetPasswordByUser } = useUserRepo(false);
    const {
        captchaUI,
        isValid: isValidCaptcha,
        handleInputCaptchaChange,
    } = useSimpleCaptcha();

    const [username, setUsername] = useState("")
    const [, setCaptcha] = useState("")
    const navigate = useNavigate()

    const onFinish = async (values) => {
        const res = await sendLinkResetPasswordByUser({ userName: username })
        if (res?.isValid && res?.statusCode === 200) {
            CustomAlert.success({
                title: Constant.message.successSendEmail,
                description: "Please check your email.",
                onConfirmButton: () => {
                    navigate(RouteConstant.login, { replace: true })
                }
            })
        }
    };

    const onFinishFailed = (errorInfo) => {
        DevLog('Failed:', errorInfo);
    };

    return (
        <div className='forgot-password-page'>
            <div className='wrap-forgot-password'>
                <Card className='card'>
                    <img src={BrandLogo} alt='brand logo' height={60} className='brand-img' />
                    <p className="auth-container-forgot-password-title">Forgot Password</p>
                    <p className="auth-container-forgot-password-subtitle">Enter your <b>username</b> and we'll send you the link to reset password</p>
                    <Form
                        name="forgot-password"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            {...propsItem}
                            name="username"
                            style={styleFormItem}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username!',
                                },
                            ]}
                        >
                            <Input placeholder='Username' onChange={(e) => {
                                setUsername(e.target.value)
                            }} />
                        </Form.Item>
                        {Constant.useCaptchaValidationForgotPassword &&
                            <>
                                <Form.Item
                                    {...propsItem}
                                    style={styleFormItem}
                                >
                                    {captchaUI}
                                </Form.Item>
                                <Form.Item
                                    {...propsItem}
                                    name="captcha"
                                    style={styleFormItem}
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                if (!isValidCaptcha) {
                                                    return Promise.reject(new Error('Invalid Captcha!'));
                                                } else {
                                                    return Promise.resolve();
                                                }
                                            }
                                        }
                                    ]}
                                >
                                    <Input placeholder='Captcha' onChange={(e) => {
                                        setCaptcha(e.target.value)
                                        handleInputCaptchaChange(e.target.value)
                                    }} />
                                </Form.Item>
                            </>
                        }

                        <div className='wrap-button'>
                            <Link to={RouteConstant.login}>
                                <Button
                                    type='primary'
                                    danger
                                    htmlType='button'
                                    disabled={isLoading}
                                    size='large'>Back to Login</Button>
                            </Link>
                            <Button type='primary' htmlType='submit' loading={isLoading} size='large'>Reset Password</Button>
                        </div>
                    </Form>
                </Card>
            </div>
        </div>
    )
}
